var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1eeac6be"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-row my-2 text-gray-400" };
const _hoisted_2 = {
    key: 0,
    class: "my-2",
    style: { "display": "flex", "align-items": "center" }
};
const _hoisted_3 = { style: { "display": "flex", "align-items": "center" } };
const _hoisted_4 = {
    key: 0,
    style: { "margin-left": "10px" }
};
const _hoisted_5 = { class: "flex justify-between items-center pr-3" };
const _hoisted_6 = { class: "flex justify-between items-center pr-3" };
const _hoisted_7 = { class: "flex justify-between items-center pr-3" };
const _hoisted_8 = { class: "flex justify-between items-center pr-3" };
const _hoisted_9 = { class: "flex justify-between items-center pr-3" };
const _hoisted_10 = { class: "flex justify-between items-center pr-3" };
const _hoisted_11 = { class: "flex justify-between items-center pr-3" };
const _hoisted_12 = { class: "flex justify-between items-center pr-3" };
const _hoisted_13 = {
    key: 2,
    class: "flex items-center"
};
const _hoisted_14 = { class: "pb-2 pl-2" };
const _hoisted_15 = { class: "flex justify-between items-center pr-3" };
const _hoisted_16 = { class: "flex justify-between items-center pr-3" };
const _hoisted_17 = { class: "flex justify-between items-center pr-3" };
const _hoisted_18 = { class: "flex justify-between items-center pr-3" };
const _hoisted_19 = { class: "flex justify-between items-center pr-3" };
const _hoisted_20 = { class: "flex flex-col w-full" };
const _hoisted_21 = { class: "flex flex-row my-2 text-gray-400" };
import MediaUpload from '@/components/MediaUpload.vue';
import { appState } from '@/composable/appState';
import { CHAT_WIDGET_IDS, ChatBubbleOptions, ChatBubbleType, ChatIconOptions, ChatWidgetSettingsDataOptions, ThemeCustomColorOptions, ThemeIcons, ThemeName, ThemeOptions, TypographyColorOptions, customTypographyColumns, customTypographyData, } from '@/helper/const';
import { googleFonts, webSafeFonts } from '@/helper/font_helper';
import { isImageStorageUrl, updateChatWidgetSetting } from '@/helper/helper';
import { i18n } from '@/plugin/vue-i18n';
import { ImagePlusIcon, InfoCircleIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIAvatar, UICard, UIColorPicker, UIDataTable, UIDivider, UIFormItem, UIInput, UIPopover, UIRadioGroup, UIRadioGroupItem, UISelect, UISpace, UISwitch, UITextXsRegular, } from '@gohighlevel/ghl-ui';
import { debounce } from 'lodash';
import { computed, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Styles',
    setup(__props) {
        const openMediaPicker = ref(false);
        const imageUrl = ref();
        const handleEdit = () => (openMediaPicker.value = true);
        const closeMediaPicker = () => (openMediaPicker.value = false);
        const updateChatIcon = (val) => {
            if (val) {
                imageUrl.value = val;
                appState.chatWidgetSettingsData.chatIcon = imageUrl.value;
                imageUrl.value = '';
                appState.unsavedChanges = true;
            }
        };
        const handleReplaceImage = () => {
            appState.chatWidgetSettingsData.chatIcon = ChatIconOptions[0].value;
            appState.unsavedChanges = true;
        };
        const updateTheme = (val) => {
            var _a, _b, _c;
            updateChatWidgetSetting('theme.name', val);
            if (val === ThemeName.CUSTOM &&
                appState.chatWidgetSettingsData.theme.colors === undefined &&
                ((_b = (_a = appState.chatWidgetSettingsData.theme) === null || _a === void 0 ? void 0 : _a.typography) === null || _b === void 0 ? void 0 : _b.colors) === undefined) {
                appState.chatWidgetSettingsData.theme.colors = {};
                for (const [key, value] of Object.entries(ThemeOptions.find(option => option.value === ThemeName.CUSTOM).colors)) {
                    appState.chatWidgetSettingsData.theme.colors[key] = value;
                    appState.unsavedChanges = true;
                }
                appState.chatWidgetSettingsData.theme.typography = {};
                appState.chatWidgetSettingsData.theme.typography.colors =
                    {};
                for (const [key, value] of Object.entries((_c = ThemeOptions.find(option => option.value === ThemeName.CUSTOM).typography) === null || _c === void 0 ? void 0 : _c.colors)) {
                    appState.chatWidgetSettingsData.theme.typography.colors[key] = value;
                    appState.unsavedChanges = true;
                }
            }
        };
        const updateColor = (val, colorOption) => {
            var _a, _b;
            if (appState.chatWidgetSettingsData.theme.colors.hasOwnProperty(colorOption)) {
                appState.chatWidgetSettingsData.theme.colors[colorOption] = val;
                appState.unsavedChanges = true;
            }
            else if ((_b = (_a = appState.chatWidgetSettingsData.theme) === null || _a === void 0 ? void 0 : _a.typography) === null || _b === void 0 ? void 0 : _b.colors.hasOwnProperty(colorOption)) {
                appState.chatWidgetSettingsData.theme.typography.colors[colorOption] = val;
                appState.unsavedChanges = true;
            }
            else if (!appState.chatWidgetSettingsData.theme.typography.colors.hasOwnProperty(colorOption)) {
                appState.chatWidgetSettingsData.theme.typography.colors[colorOption] = val;
                appState.unsavedChanges = true;
            }
        };
        const updateFontFamily = (val) => {
            var _a;
            if (!((_a = appState.chatWidgetSettingsData.theme) === null || _a === void 0 ? void 0 : _a.typography)) {
                appState.chatWidgetSettingsData.theme.typography = {};
            }
            appState.chatWidgetSettingsData.theme.typography.fontFamily = val;
            appState.unsavedChanges = true;
        };
        const fonts = ref([]);
        const allFonts = [...googleFonts, ...webSafeFonts];
        fonts.value = allFonts.map(val => ({
            label: val,
            value: val,
        }));
        const onSearch = debounce((search) => __awaiter(this, void 0, void 0, function* () {
            if (search.trim() === '') {
                fonts.value = allFonts.map(val => ({
                    label: val,
                    value: val,
                }));
            }
            else {
                fonts.value = allFonts
                    .filter(font => font.toLowerCase().includes(search.toLowerCase()))
                    .map(val => ({
                    label: val,
                    value: val,
                }));
            }
        }), 300);
        const updateChatWidgetPromptType = (val) => {
            appState.chatWidgetSettingsData.promptType = val;
            if (appState.chatWidgetSettingsData.promptType === ChatBubbleType.AVATAR) {
                appState.chatWidgetSettingsData.allowAvatarImage = true;
            }
            appState.unsavedChanges = true;
        };
        const isChatIconImage = computed(() => { var _a; return isImageStorageUrl((_a = appState.chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.chatIcon); });
        const updateShowPrompt = (val) => {
            if (val === false) {
                appState.chatWidgetSettingsData.enableRevisitMessage = false;
                updateChatWidgetSetting(ChatWidgetSettingsDataOptions.SHOW_PROMPT, val);
            }
            else {
                appState.chatWidgetSettingsData.enableRevisitMessage = true;
                updateChatWidgetSetting(ChatWidgetSettingsDataOptions.SHOW_PROMPT, val);
            }
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(UISwitch), {
                        rubberBand: false,
                        value: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.showPrompt,
                        "onUpdate:value": _cache[0] || (_cache[0] = val => updateShowPrompt(val))
                    }, null, 8 /* PROPS */, ["value"]),
                    _createVNode(_unref(UIFormItem), {
                        label: _ctx.$t('sidebar.chatPrompt'),
                        "show-feedback": false,
                        class: "ml-2 mt-0.5"
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                (((_b = _unref(appState).chatWidgetSettingsData) === null || _b === void 0 ? void 0 : _b.showPrompt) === true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (((_c = _unref(appState).chatWidgetSettingsData) === null || _c === void 0 ? void 0 : _c.showPrompt) === true)
                            ? (_openBlock(), _createBlock(_unref(UIRadioGroup), {
                                key: 0,
                                value: (_d = _unref(appState).chatWidgetSettingsData) === null || _d === void 0 ? void 0 : _d.promptType,
                                name: "ChatBubbleOptions",
                                "onUpdate:value": _cache[1] || (_cache[1] = val => updateChatWidgetPromptType(val))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UISpace), null, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ChatBubbleOptions), (item) => {
                                                return (_openBlock(), _createBlock(_unref(UIRadioGroupItem), {
                                                    key: item.value,
                                                    value: item.value,
                                                    compact: true,
                                                    class: "theme"
                                                }, {
                                                    icon: _withCtx(() => [
                                                        (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { style: { "width": "90px", "height": "90px" } }))
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["value"]))
                            : _createCommentVNode("v-if", true)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(UIDivider)),
                _createVNode(_unref(UIFormItem), {
                    label: _ctx.$t('sidebar.chatIcon'),
                    "show-feedback": false,
                    class: "my-2"
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            _createVNode(_unref(UIRadioGroup), {
                                value: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.chatIcon,
                                name: "ChatIconOptions",
                                "onUpdate:value": _cache[2] || (_cache[2] =
                                    val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).CHAT_ICON, val))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UISpace), null, {
                                        default: _withCtx(() => {
                                            var _a;
                                            return [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ChatIconOptions), (item) => {
                                                    return (_openBlock(), _createBlock(_unref(UIRadioGroupItem), {
                                                        key: item.value,
                                                        value: item.value,
                                                        compact: true,
                                                        class: "p-2"
                                                    }, {
                                                        icon: _withCtx(() => [
                                                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-6 h-6" }))
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                                                }), 128 /* KEYED_FRAGMENT */)),
                                                _createElementVNode("div", _hoisted_3, [
                                                    (_openBlock(), _createBlock(_unref(UIAvatar), {
                                                        key: _unref(isChatIconImage),
                                                        id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_AVATAR,
                                                        size: 42,
                                                        objectFit: "fill",
                                                        round: true,
                                                        src: _unref(isChatIconImage) ? (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.chatIcon : null,
                                                        onClick: handleEdit
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (!_unref(isChatIconImage))
                                                                ? (_openBlock(), _createBlock(_unref(ImagePlusIcon), {
                                                                    key: 0,
                                                                    class: "w-4 h-4"
                                                                }))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["id", "src"])),
                                                    (_unref(isChatIconImage))
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                                            _createVNode(_unref(UITextXsRegular), {
                                                                role: "button",
                                                                onClick: handleReplaceImage,
                                                                class: "text-error-500 cursor-pointer"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.remove')), 1 /* TEXT */)
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            })
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ];
                                        }),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["value"])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createVNode(_unref(UIDivider)),
                _createVNode(_unref(UIFormItem), {
                    label: _ctx.$t('sidebar.theme'),
                    "show-feedback": false,
                    class: "my-2"
                }, {
                    default: _withCtx(() => {
                        var _a, _b;
                        return [
                            _createVNode(_unref(UIRadioGroup), {
                                value: (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.name,
                                name: "ThemeOptions",
                                "onUpdate:value": _cache[3] || (_cache[3] = val => updateTheme(val))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UISpace), { justify: "space-evenly" }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ThemeOptions), (item) => {
                                                return (_openBlock(), _createBlock(_unref(UIRadioGroupItem), {
                                                    key: item.value,
                                                    value: item.value,
                                                    compact: true,
                                                    class: "theme"
                                                }, {
                                                    icon: _withCtx(() => [
                                                        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ThemeIcons)[item.value]), { style: { "width": "90px", "height": "90px" } }))
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["value"])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                (((_f = (_e = _unref(appState).chatWidgetSettingsData) === null || _e === void 0 ? void 0 : _e.theme) === null || _f === void 0 ? void 0 : _f.name) === _unref(ThemeName).CUSTOM)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 1,
                        label: _ctx.$t('sidebar.themeCustomColorOptions'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UICard), { class: "w-full" }, {
                                default: _withCtx(() => {
                                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
                                    return [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.chatBubbleColor')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _createVNode(_unref(UIColorPicker), {
                                                value: (_c = (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.chatBubbleColor,
                                                compact: true,
                                                modes: ['hex', 'rgb'],
                                                "onUpdate:value": _cache[4] || (_cache[4] =
                                                    val => updateColor(val, _unref(ThemeCustomColorOptions).CHAT_BUBBLE_COLOR))
                                            }, null, 8 /* PROPS */, ["value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.backgroundColor')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _createVNode(_unref(UIColorPicker), {
                                                value: (_f = (_e = (_d = _unref(appState).chatWidgetSettingsData) === null || _d === void 0 ? void 0 : _d.theme) === null || _e === void 0 ? void 0 : _e.colors) === null || _f === void 0 ? void 0 : _f.backgroundColor,
                                                compact: true,
                                                modes: ['hex', 'rgb'],
                                                "onUpdate:value": _cache[5] || (_cache[5] =
                                                    val => updateColor(val, _unref(ThemeCustomColorOptions).BACKGROUND_COLOR))
                                            }, null, 8 /* PROPS */, ["value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.headerColor')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _createVNode(_unref(UIColorPicker), {
                                                value: (_j = (_h = (_g = _unref(appState).chatWidgetSettingsData) === null || _g === void 0 ? void 0 : _g.theme) === null || _h === void 0 ? void 0 : _h.colors) === null || _j === void 0 ? void 0 : _j.headerColor,
                                                compact: true,
                                                modes: ['hex', 'rgb'],
                                                "onUpdate:value": _cache[6] || (_cache[6] =
                                                    val => updateColor(val, _unref(ThemeCustomColorOptions).HEADER_COLOR))
                                            }, null, 8 /* PROPS */, ["value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.buttonColor')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _createVNode(_unref(UIColorPicker), {
                                                value: (_m = (_l = (_k = _unref(appState).chatWidgetSettingsData) === null || _k === void 0 ? void 0 : _k.theme) === null || _l === void 0 ? void 0 : _l.colors) === null || _m === void 0 ? void 0 : _m.buttonColor,
                                                compact: true,
                                                modes: ['hex', 'rgb'],
                                                "onUpdate:value": _cache[7] || (_cache[7] =
                                                    val => updateColor(val, _unref(ThemeCustomColorOptions).BUTTON_COLOR))
                                            }, null, 8 /* PROPS */, ["value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.avatarBackgroundColor')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _createVNode(_unref(UIColorPicker), {
                                                value: (_q = (_p = (_o = _unref(appState).chatWidgetSettingsData) === null || _o === void 0 ? void 0 : _o.theme) === null || _p === void 0 ? void 0 : _p.colors) === null || _q === void 0 ? void 0 : _q.avatarBackgroundColor,
                                                compact: true,
                                                modes: ['hex', 'rgb'],
                                                "onUpdate:value": _cache[8] || (_cache[8] =
                                                    val => updateColor(val, _unref(ThemeCustomColorOptions).AVATAR_BACKGROUND_COLOR))
                                            }, null, 8 /* PROPS */, ["value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.avatarBorderColor')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _createVNode(_unref(UIColorPicker), {
                                                value: (_t = (_s = (_r = _unref(appState).chatWidgetSettingsData) === null || _r === void 0 ? void 0 : _r.theme) === null || _s === void 0 ? void 0 : _s.colors) === null || _t === void 0 ? void 0 : _t.avatarBorderColor,
                                                compact: true,
                                                modes: ['hex', 'rgb'],
                                                "onUpdate:value": _cache[9] || (_cache[9] =
                                                    val => updateColor(val, _unref(ThemeCustomColorOptions).AVATAR_BORDER_COLOR))
                                            }, null, 8 /* PROPS */, ["value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.senderMessageColor')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _createVNode(_unref(UIColorPicker), {
                                                value: (_w = (_v = (_u = _unref(appState).chatWidgetSettingsData) === null || _u === void 0 ? void 0 : _u.theme) === null || _v === void 0 ? void 0 : _v.colors) === null || _w === void 0 ? void 0 : _w.senderMessageColor,
                                                compact: true,
                                                modes: ['hex', 'rgb'],
                                                "onUpdate:value": _cache[10] || (_cache[10] =
                                                    val => updateColor(val, _unref(ThemeCustomColorOptions).SENDER_MESSAGE_COLOR))
                                            }, null, 8 /* PROPS */, ["value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('sidebar.receivedMessageColor')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _createVNode(_unref(UIColorPicker), {
                                                value: (_z = (_y = (_x = _unref(appState).chatWidgetSettingsData) === null || _x === void 0 ? void 0 : _x.theme) === null || _y === void 0 ? void 0 : _y.colors) === null || _z === void 0 ? void 0 : _z.receivedMessageColor,
                                                compact: true,
                                                modes: ['hex', 'rgb'],
                                                "onUpdate:value": _cache[11] || (_cache[11] =
                                                    val => updateColor(val, _unref(ThemeCustomColorOptions).RECEIVED_MESSAGE_COLOR))
                                            }, null, 8 /* PROPS */, ["value"])
                                        ])
                                    ];
                                }),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (((_h = (_g = _unref(appState).chatWidgetSettingsData) === null || _g === void 0 ? void 0 : _g.theme) === null || _h === void 0 ? void 0 : _h.name) === _unref(ThemeName).CUSTOM)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_unref(UIFormItem), {
                            label: _ctx.$t('sidebar.typography'),
                            "show-feedback": false,
                            class: "my-2"
                        }, null, 8 /* PROPS */, ["label"]),
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_unref(UIPopover), {
                                trigger: "hover",
                                placement: "left"
                            }, {
                                trigger: _withCtx(() => [
                                    _createVNode(_unref(InfoCircleIcon), { class: "w-4 h-4" })
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIDataTable), {
                                        style: { "width": "500px" },
                                        columns: _unref(customTypographyColumns)(),
                                        data: _unref(customTypographyData)()
                                    }, null, 8 /* PROPS */, ["columns", "data"])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                (((_k = (_j = _unref(appState).chatWidgetSettingsData) === null || _j === void 0 ? void 0 : _j.theme) === null || _k === void 0 ? void 0 : _k.name) === _unref(ThemeName).CUSTOM)
                    ? (_openBlock(), _createBlock(_unref(UICard), {
                        key: 3,
                        class: "w-full"
                    }, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
                            return [
                                _createVNode(_unref(UIFormItem), {
                                    label: _ctx.$t('sidebar.fontFamily'),
                                    "show-feedback": false,
                                    class: "my-2"
                                }, {
                                    default: _withCtx(() => {
                                        var _a, _b, _c;
                                        return [
                                            _createVNode(_unref(UISelect), {
                                                id: "select-id",
                                                value: (_c = (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.typography) === null || _c === void 0 ? void 0 : _c.fontFamily,
                                                options: fonts.value,
                                                "reset-menu-on-options-change": false,
                                                filterable: true,
                                                placeholder: "Select one",
                                                remote: "",
                                                onSearch: _unref(onSearch),
                                                "onUpdate:value": _cache[12] || (_cache[12] = val => updateFontFamily(val))
                                            }, null, 8 /* PROPS */, ["value", "options", "onSearch"])
                                        ];
                                    }),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.senderMessageTextColor')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_unref(UIColorPicker), {
                                        value: (_d = (_c = (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.typography) === null || _c === void 0 ? void 0 : _c.colors) === null || _d === void 0 ? void 0 : _d.senderMessageTextColor,
                                        compact: true,
                                        modes: ['hex', 'rgb'],
                                        "onUpdate:value": _cache[13] || (_cache[13] =
                                            val => updateColor(val, _unref(TypographyColorOptions).SENDER_MESSAGE_TEXT_COLOR))
                                    }, null, 8 /* PROPS */, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.receivedMessageTextColor')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_unref(UIColorPicker), {
                                        value: (_h = (_g = (_f = (_e = _unref(appState).chatWidgetSettingsData) === null || _e === void 0 ? void 0 : _e.theme) === null || _f === void 0 ? void 0 : _f.typography) === null || _g === void 0 ? void 0 : _g.colors) === null || _h === void 0 ? void 0 : _h.receivedMessageTextColor,
                                        compact: true,
                                        modes: ['hex', 'rgb'],
                                        "onUpdate:value": _cache[14] || (_cache[14] =
                                            val => updateColor(val, _unref(TypographyColorOptions).RECEIVED_MESSAGE_TEXT_COLOR))
                                    }, null, 8 /* PROPS */, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.headerMessageTextColor')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_unref(UIColorPicker), {
                                        value: (_m = (_l = (_k = (_j = _unref(appState).chatWidgetSettingsData) === null || _j === void 0 ? void 0 : _j.theme) === null || _k === void 0 ? void 0 : _k.typography) === null || _l === void 0 ? void 0 : _l.colors) === null || _m === void 0 ? void 0 : _m.headerMessageTextColor,
                                        compact: true,
                                        modes: ['hex', 'rgb'],
                                        "onUpdate:value": _cache[15] || (_cache[15] =
                                            val => updateColor(val, _unref(TypographyColorOptions).HEADER_MESSAGE_TEXT_COLOR))
                                    }, null, 8 /* PROPS */, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.systemMessageTextColor')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_unref(UIColorPicker), {
                                        value: (_r = (_q = (_p = (_o = _unref(appState).chatWidgetSettingsData) === null || _o === void 0 ? void 0 : _o.theme) === null || _p === void 0 ? void 0 : _p.typography) === null || _q === void 0 ? void 0 : _q.colors) === null || _r === void 0 ? void 0 : _r.systemMessageTextColor,
                                        compact: true,
                                        modes: ['hex', 'rgb'],
                                        "onUpdate:value": _cache[16] || (_cache[16] =
                                            val => updateColor(val, _unref(TypographyColorOptions).SYSTEM_MESSAGE_TEXT_COLOR))
                                    }, null, 8 /* PROPS */, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createVNode(_unref(UITextXsRegular), { class: "mr-4" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('sidebar.welcomeMessageTextColor')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_unref(UIColorPicker), {
                                        value: (_v = (_u = (_t = (_s = _unref(appState).chatWidgetSettingsData) === null || _s === void 0 ? void 0 : _s.theme) === null || _t === void 0 ? void 0 : _t.typography) === null || _u === void 0 ? void 0 : _u.colors) === null || _v === void 0 ? void 0 : _v.welcomeMessageTextColor,
                                        compact: true,
                                        modes: ['hex', 'rgb'],
                                        "onUpdate:value": _cache[17] || (_cache[17] =
                                            val => updateColor(val, _unref(TypographyColorOptions).WELCOME_MESSAGE_TEXT_COLOR))
                                    }, null, 8 /* PROPS */, ["value"])
                                ])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }))
                    : _createCommentVNode("v-if", true),
                ((_l = _unref(appState).chatWidgetSettingsData) === null || _l === void 0 ? void 0 : _l.showPrompt)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createVNode(_unref(UIDivider)),
                        _createVNode(_unref(UIFormItem), {
                            label: _ctx.$t('sidebar.welcomeMessage'),
                            "show-feedback": false,
                            class: "my-2"
                        }, {
                            default: _withCtx(() => {
                                var _a;
                                return [
                                    _createVNode(_unref(UIInput), {
                                        type: "textarea",
                                        rows: 4,
                                        id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                        modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.promptMsg,
                                        placeholder: _unref(i18n).global.t('placeholder.promptMsg'),
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] =
                                            val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).PROMPT_MSG, val))
                                    }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                                ];
                            }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(_unref(UIFormItem), {
                            label: _ctx.$t('sidebar.returnVisitorCustomGreetings'),
                            "show-feedback": false
                        }, {
                            default: _withCtx(() => {
                                var _a, _b, _c, _d;
                                return [
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                            _createVNode(_unref(UISwitch), {
                                                rubberBand: false,
                                                value: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.enableRevisitMessage,
                                                "onUpdate:value": _cache[19] || (_cache[19] =
                                                    val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).ENABLE_REVISIT_MESSAGE, val))
                                            }, null, 8 /* PROPS */, ["value"]),
                                            _createVNode(_unref(UIFormItem), {
                                                label: _ctx.$t('sidebar.enableCustomGreeting'),
                                                "show-feedback": false,
                                                class: "ml-2 mt-0.5"
                                            }, null, 8 /* PROPS */, ["label"])
                                        ]),
                                        (((_b = _unref(appState).chatWidgetSettingsData) === null || _b === void 0 ? void 0 : _b.enableRevisitMessage) === true)
                                            ? (_openBlock(), _createBlock(_unref(UIInput), {
                                                key: 0,
                                                type: "textarea",
                                                rows: 4,
                                                id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                                modelValue: (_c = _unref(appState).chatWidgetSettingsData) === null || _c === void 0 ? void 0 : _c.revisitPromptMsg,
                                                placeholder: _unref(i18n).global.t('placeholder.revisitPromptMsg'),
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] =
                                                    val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).REVISIT_PROMPT_MSG, val))
                                            }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"]))
                                            : _createCommentVNode("v-if", true),
                                        (((_d = _unref(appState).chatWidgetSettingsData) === null || _d === void 0 ? void 0 : _d.enableRevisitMessage) === true)
                                            ? (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                                                key: 1,
                                                innerHTML: _ctx.$t('sidebar.enableRevisitMessageHelper')
                                            }, null, 8 /* PROPS */, ["innerHTML"]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ];
                            }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"])
                    ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                (_openBlock(), _createBlock(_Teleport, { to: 'body' }, [
                    (openMediaPicker.value)
                        ? (_openBlock(), _createBlock(MediaUpload, {
                            key: 0,
                            allowedExtensions: ['image'],
                            openMediaPicker: openMediaPicker.value,
                            onClose: closeMediaPicker,
                            onChangeUrl: _cache[21] || (_cache[21] = val => updateChatIcon(val)),
                            maxUploadSize: 10000000
                        }, null, 8 /* PROPS */, ["openMediaPicker"]))
                        : _createCommentVNode("v-if", true)
                ]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
